<template>
    <app-erros-box :erros="erros"></app-erros-box>
</template>

<script>
import ComprometimentosServicos from './ComprometimentosServicos'

export default {
    data() {
        return {
            erros: []
        }
    },

    methods: {
        iniciar() {
            this.$store.dispatch('addRequest')
            ComprometimentosServicos.iniciarExclusao().then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Processo realizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.btnIniciarDesabilitado = false
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted() {
        this.iniciar()
    }
}
</script>
